import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Scan from './Scan';

import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CreateMedicine from './pages/CreateMedicine';
import UnitsList from './components/UnitsList';
import ScanPage from './components/ScanPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CreateMedicine />} />
        <Route path="/scan" element={<Scan />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/unitlists" element={<UnitsList />} />
        <Route path="/scanpage" element={<ScanPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
